/**
 * Google Analytics 4 — 앰플리튜드와 **같은 이벤트를 함께** 보낸다.
 * @description 두 도구는 보는 사람이 다르다. 앰플리튜드는 제품 퍼널(누가 어디서 이탈했나),
 *   GA 는 유입(어느 광고·어느 링크에서 왔나)을 본다. 하나만 심으면 광고비를 집행한 쪽과
 *   제품을 고치는 쪽이 서로 다른 숫자를 들고 회의에 들어온다.
 *
 *   스크립트 자체는 루트 레이아웃이 이미 싣는다. 여기서는 `gtag` 가 준비됐을 때만 부른다 —
 *   광고 차단기가 흔해서 없는 경우가 정상이다.
 *
 *   이름은 GA4 규칙(소문자·언더스코어)으로 바꿔 보낸다. 앰플리튜드 쪽 이름
 *   (`Collab Viewed`)은 앱과 맞춰야 해서 그대로 두고, 여기서만 `collab_viewed` 가 된다.
 */
type Gtag = (
  command: "event",
  eventName: string,
  params?: Record<string, unknown>,
) => void;

/** `Collab App Opened` → `collab_app_opened`. GA4 는 영숫자와 언더스코어만 받는다. */
function toGaName(eventName: string): string {
  return eventName
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .toLowerCase();
}

export function gaEvent(
  eventName: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === "undefined") return;

  const gtag = (window as unknown as { gtag?: Gtag }).gtag;
  if (typeof gtag !== "function") return;

  gtag("event", toGaName(eventName), params);
}
